import Application from "../../Application";
import OrganisationIndexGroupPresenter, {
  IOrganisationIndexGroupPresenter
} from "../presenter/OrganisationIndexGroupPresenter";
import GetIndexTypeGroupTreeInteractor from "./GetIndexTypeGroupTreeInteractor";
import GetAllOrganisationsInteractor from "./GetAllOrganisationsInteractor";
import GetAllIndexTypesInteractor from "../../indexTypes/interactors/GetAllIndexTypesInteractor";
import GetAllIndexTypeGroupsInteractor from "../../indexTypes/interactors/GetAllIndexTypeGroupsInteractor";
import GetAllOrganisationIndexGroupsInteractor from "./GetAllOrganisationIndexGroupsInteractor";

export default class ShowOrganisationIndexGroupInteractor {
  private application: Application;
  private output?: IOrganisationIndexGroupPresenter;
  private getIndexTypeGroupTreeInteractor: GetIndexTypeGroupTreeInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getAllIndexTypesInteractor: GetAllIndexTypesInteractor;
  private getAllIndexTypeGroupsInteractor: GetAllIndexTypeGroupsInteractor;
  private getAllOrganisationIndexGroupsInteractor: GetAllOrganisationIndexGroupsInteractor;

  constructor({
    application,
    getIndexTypeGroupTree,
    getAllOrganisations,
    getAllIndexTypes,
    getAllIndexTypeGroups,
    getAllOrganisationIndexGroups
  }) {
    this.application = application;
    this.getIndexTypeGroupTreeInteractor = getIndexTypeGroupTree;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getAllIndexTypesInteractor = getAllIndexTypes;
    this.getAllIndexTypeGroupsInteractor = getAllIndexTypeGroups;
    this.getAllOrganisationIndexGroupsInteractor =
      getAllOrganisationIndexGroups;
  }
  private async getReferenceLists(organisationId) {
    return Promise.all([
      this.getAllOrganisationsInteractor.execute(),
      this.getAllIndexTypesInteractor.execute(),
      this.getAllIndexTypeGroupsInteractor.execute(),
      this.getAllOrganisationIndexGroupsInteractor.execute(organisationId)
    ]);
  }
  execute(organisationId, categoryId) {
    this.output = OrganisationIndexGroupPresenter({
      application: this.application,
      initialState: {
        organisationIndexDataTree: [],
        organisationId: NaN,
        categoryId: NaN,
        indexTypeGroupId: NaN,
        indexTypeId: NaN,
        createGroupModalVisible: false,
        createItemModalVisible: false,
        indexesModalVisible: false,
        groupsModalVisible: false,
        organisationTypeGroupId: NaN,
        searchableOrganisationIndexDataTree: [],
        indexesNotInOrganisation: [],
        groupModelsCandidates: [],
        groupsCandidates: [],
        organisations: [],
        indexTypes: [],
        selectedIndexes: [],
        selectedGroups: [],
        indexInfoVisible: false,
        groupInfoVisible: false,
        updateIndexModalVisible: false,
        updateIndexGroupModalVisible: false,
        filterByParentNameChecked: false,
        filterGroupByParentNameChecked: false,
        indexTypeGroups: [],
        allGroups: [],
        caseLawDocsModalVisible: false,
        deleteWarningModalVisible: false,
        switchGroupVisible: false,
        deleteGroupModalVisible: false,
        deleteGroupWarningVisible: false,
        selectedIndexesByCategory: [],
        connectedIndexesByCategory: []
      }
    });
    this.getReferenceLists(organisationId)
      .then(([organisations, indexTypes, indexTypeGroups, allGroups]) =>
        this.output?.loadReferenceValues(
          organisationId,
          categoryId,
          organisations,
          indexTypes,
          indexTypeGroups,
          allGroups
        )
      )
      .then(() =>
        this.getIndexTypeGroupTreeInteractor.execute(organisationId, categoryId)
      )
      .then(this.output.loadData);
    return this.output;
  }
}
